import React, { useState, useEffect } from 'react';
import './css/studentManagement.css';
import StudentProfile from './profile/js/studentProfile';
import StudentTable from './table/js/studentTable';
import StudentCreate from './create/js/studentCreate';
import { studentAPI } from '../../utils/api';
import PropTypes from 'prop-types';

function StudentManagement({ initialTab = 'students', onTabChange }) {
  const [activeTab, setActiveTab] = useState(initialTab);
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [reloadKey, setReloadKey] = useState(0);

  useEffect(() => {
    setActiveTab(initialTab);
    if (onTabChange) {
      onTabChange(initialTab);
    }
  }, [initialTab, onTabChange]);

  const getPageHeader = () => {
    switch (activeTab) {
      case 'profile':
        return {
          title: 'Student Profile',
          description: 'Manage your personal profile and account settings',
        };
      case 'students':
        return {
          title: 'Students Management',
          description: 'View and manage all student records',
        };
      default:
        return {
          title: 'Students Management',
          description: 'View and manage all student records',
        };
    }
  };

  const renderContent = () => {
    switch (activeTab) {
      case 'profile':
        return <StudentProfile />;
      case 'students':
        return <StudentTable reloadKey={reloadKey} onCreateStudent={() => setShowCreateModal(true)} />;
      default:
        return <StudentTable reloadKey={reloadKey} onCreateStudent={() => setShowCreateModal(true)} />;
    }
  };

  const headerData = getPageHeader();

  return (
    <div className="eduss-student-management">
      <div className="eduss-page-header">
        <div>
          <h2>{headerData.title}</h2>
          <p>{headerData.description}</p>
        </div>
        <div className="eduss-dashboard-banner-date">
          Tuesday, July 15, 2025
        </div>
      </div>

      <div className="eduss-student-management-content">{renderContent()}</div>

      {/* Create Student Modal */}
      {showCreateModal && (
        <div
          className="eduss-global-modal-overlay"
          onClick={() => setShowCreateModal(false)}
        >
          <div
            className="eduss-global-modal eduss-admin-form-modal"
            onClick={e => e.stopPropagation()}
          >
            <div className="eduss-global-modal-header">
              <h3>Create New Student Record</h3>
              <button onClick={() => setShowCreateModal(false)}>&times;</button>
            </div>
            <div className="eduss-global-modal-content">
              <StudentCreate
                onClose={() => setShowCreateModal(false)}
                onSubmit={async (form) => {
                  try {
                    await studentAPI.create(form);
                    setReloadKey(k => k + 1);
                    setShowCreateModal(false);
                  } catch (err) {
                    // Surface API error if available
                    const msg = err?.response?.data?.error || err.message || 'Failed to create student';
                    alert(msg);
                  }
                }}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

StudentManagement.propTypes = {
  initialTab: PropTypes.string,
  onTabChange: PropTypes.func,
};

export default StudentManagement;
